export const Seperator = () => (
  <div className="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />
);
